var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');
var DataTable = require('../../lib/datatable.js');
var Columnator = require('../../lib/columnator.js');
var Vue = require('vue');
var ExportActionDropdown = require('../../lib/components/Exports/ExportActionDropdown.vue').default;

module.exports = function() {
    var datatable = new DataTable;

    datatable.setup('.datatable');

    $('.filtertron-tray').filtertronTray({
        onOpen: function() {
            datatable.refresh();
        },
        onClose: function() {
            datatable.refresh();
        }
    });

    new Vue({
        el: '#export-action',
        components: {
            'export-action-dropdown': ExportActionDropdown
        }
    });

    var marker = new Marker('orders');

    new Deletism(marker);
    new Undeletism(marker);

    new Columnator();
};
